import Api from "../../axios";

export default async function onBoardEmployee(data) {
  // console.log("data", data);

  return await Api.post("/on_boarding", data);
}
